/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { defineStore } from 'pinia';
import { to } from '@tencent/wphk-base-utils';
import { getConfig } from '@/api';
import { CustomException } from '@tencent/ppd-base-libs';
import { GoodDeedDayNewsType, GoodDeedDayNGOType } from '@/types';


export const useConfigStore = defineStore({
  id: 'configStore', // 必填

  state: () => ({
    isInit: false,
    goodDeedDayNGO: {} as { [key: string]: GoodDeedDayNGOType },
    goodDeedDayNews: [] as GoodDeedDayNewsType[],
  }),

  getters: {}, // 非必要转换别填

  actions: {
    async getConfig() {
      const [err, res] = await to(getConfig());
      if (err) {
        console.error('getConfig', err);
        // const errMsg = i18n('配置異常，請重試');
        // 弹窗报错
        // showErrorDialog({
        //   message: errMsg,
        // });
        throw new CustomException(err, 'goodDeedDayConfigFail', '每日一善加载配置失敗');
      }
      console.log('前端配置初始化结果,当前配置为：', res);

      this.isInit = true;

      const ngo = {};
      for (const item of res.goodDeedDayNGO) {
        ngo[item.key] = item;
      }
      this.goodDeedDayNGO = ngo;
      this.goodDeedDayNews = (res.goodDeedDayNews || []).sort((a, b) => parseInt(a.order, 10) - parseInt(b.order, 10));
    },
  },
});
